import { useQuery } from "@tanstack/react-query";
import $api from "../api/axios";
import { useEffect } from "react";
import { useAdminStore } from "../../stores/admin-store";

type AdminUser = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  organizationId: number;
  isDemo: boolean;
  role: string;
  hasAdminPanelAccess: boolean;
  customSnippetsUrl: string | null;
};

export const useAuthenticated = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["admin-session-verify"],
    queryFn: async (): Promise<AdminUser | null> => {
      try {
        const response = await $api.post("/auth/verify-admin-panel-access");
        return response?.data?.data as AdminUser;
      } catch {
        return null;
      }
    }
  });

  const { setUser } = useAdminStore();

  useEffect(() => {
    if (data) {
      setUser(data);
    }
  }, [data, setUser]);

  return {
    isAuthenticated: !!data?.email,
    isLoading,
    refetch,
    user: data
  };
};
